module.exports = __webpack_public_path__ + "media/videos/l_affinity-d95de9b53ec17ff9e7e77b55bc35ceb3.mp4";